import { Form } from '@unform/web';
import ButtonLoading from 'components/atom/ButtonLoading';
import CircularLoading from 'components/atom/Loading/CircularLoading';
import FormInputMask from 'components/Form/Input/InputMask';
import Radio from 'components/Form/Radio';
import SelectSimple from 'components/Form/SelectSimple';
import Icone from 'components/Icone';
import Modal from 'components/modal/base';
import React, { FC, memo } from 'react';
import { useQueryData } from './hooks/useQueryData';
import { Container, Header, Table } from './styl';
import Input from 'components/Form/Input';
const PageEditarStatusColeta: FC<any> = () => {
    const {
        handleChangeSelect,
        handleChangeSelectStatus,
        optionSelectedStatus,
        loading,
        allStatus,
        optionsPlayer,
        ref,
        loadingButton,
        toggleStatus,
        ...unformProps
    } = useQueryData();
    const newSelectStatus = allStatus
        .filter(status => status.id !== 8)
        .map((status) => ({
            value: status.id,
            label: status.nome,
        }));
    return (
        <Modal
            render={({ closeModal }) => (
                <Container>
                    <Header>
                        <h1>Editar status da coleta</h1>
                        <button onClick={closeModal}>
                            <Icone
                                icone="icon-fechar"
                                size="2rem"
                                color="var(--btn-admin-icone)"
                            />
                        </button>
                    </Header>
                    {<CircularLoading show={loading} />}

                    {!loading && (
                        <Form ref={ref} {...unformProps}>
                            <label className="title-title">
                                Selecione o entregador desta coleta
                            </label>
                            <SelectSimple
                                onChange={handleChangeSelect}
                                name="entregador"
                                options={optionsPlayer}
                            />
                            <label className="title-title">
                                Selecione até o status que deseja alterar.
                            </label>
                            <SelectSimple
                                onChange={handleChangeSelectStatus}
                                name="status"
                                options={newSelectStatus}
                            />
                            {`${optionSelectedStatus?.value}` === '6' &&
                                <>
                                    <label className="title-title">
                                        Digite o código de confirmação da entrega
                                    </label>
                                    <Input
                                        name={`codigo_entrega`}
                                    />
                                </>
                            }
                            <div className="space-button">
                                <ButtonLoading
                                    loading={loadingButton}
                                    value={'Salvar'}
                                />
                            </div>
                        </Form>
                    )}
                </Container>
            )}
        />
    );
};
export default memo(PageEditarStatusColeta);
